import * as React from "react";
import { useQuery } from "@grandvisionhq/graphql";
import { useFeatureToggles, useIntl } from "@grandvisionhq/state";
import { mapManufacturerToClient } from "./map-to-manufacturer.js";
import { ProductDetailManufacturer } from "./ProductDetailManufacturer.js";
import { GET_MANUFACTURER_BY_KEY } from "../../../../../../operations/queries/operations/queries/get-manufacturer-by-key.js";
import { useProductData } from "../../../../../../context/context/product-context-hooks.js";
const ProductDetailManufacturerDrawerConditionalWrapper = () => {
  const { isManufacturerDetailsOnPdpEnabled } = useFeatureToggles();
  if (!isManufacturerDetailsOnPdpEnabled) return null;
  return /* @__PURE__ */ React.createElement(ProductDetailManufacturerDrawerContainer, null);
};
const ProductDetailManufacturerDrawerContainer = () => {
  const { getLabel } = useIntl();
  const { product } = useProductData();
  const hasAssets = product.variants.some((variant) => variant.assets.length > 0);
  const title = getLabel("products.detail.manufacturer.title");
  const { data, error } = useQuery(
    GET_MANUFACTURER_BY_KEY,
    {
      skip: !product.brandName,
      variables: { key: product.brandName ?? "" }
    }
  );
  const manufacturer = React.useMemo(() => {
    return mapManufacturerToClient(data?.manufacturer);
  }, [data]);
  const shouldShowDrawer = !!manufacturer || hasAssets;
  if (error || !shouldShowDrawer) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    "section",
    {
      className: "product-detail-manufacturer",
      "aria-label": title,
      "data-t": "product-detail-manufacturer"
    },
    /* @__PURE__ */ React.createElement(ProductDetailManufacturer, { title, ...manufacturer })
  );
};
export {
  ProductDetailManufacturerDrawerConditionalWrapper
};
//# sourceMappingURL=ProductDetailManufacturerDrawerContainer.js.map
